<div class="upload-dialog-wrapper">

  <!-- Header -->
  <div class="upload-dialog-header">
    <button class="back-btn" (click)="close()" [disabled]="isUploading" title="Close">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>

  <!-- Title -->
  <h2 class="upload-dialog-title">{{ data.title }}</h2>
  <p class="upload-dialog-subtitle">
    Please select a PDF or image file to attach it to this booking.
  </p>

  <!-- Upload Area -->
  <div class="upload-area-container">
    <div class="upload-drop-zone" [class.has-file]="selectedFile" (click)="openFilePicker()">
      <div class="upload-icon-circle">
        <mat-icon>{{ selectedFile ? 'description' : 'picture_as_pdf' }}</mat-icon>
      </div>

      <div class="file-info" *ngIf="selectedFile">
        <span class="file-name">{{ selectedFile.name }}</span>
        <span class="file-size">{{ (selectedFile.size / 1024).toFixed(1) }} KB</span>
      </div>

      <p class="upload-prompt" *ngIf="!selectedFile">
        Drag &amp; drop your file here or <strong>browse</strong>
      </p>

      <input type="file" #fileInput (change)="onFileSelected($event)" accept=".pdf,image/*" hidden />
    </div>

    <!-- Document Name Field -->
    <div class="custom-name-field" *ngIf="selectedFile">
      <label class="name-label">
        Document Name <span class="required">*</span>
      </label>
      <input
        type="text"
        #nameInput
        [(ngModel)]="documentName"
        placeholder="e.g. L-QTN-2025-001"
        class="name-input"
        (focus)="nameInput.style.borderColor = '#1d4ed8'"
        (blur)="nameInput.style.borderColor = '#cbd5e1'"
      />
    </div>

    <!-- Upload Button -->
    <div class="upload-actions" *ngIf="selectedFile">
      <button
        mat-flat-button
        color="primary"
        class="confirm-upload-btn"
        [disabled]="!selectedFile || isUploading"
        (click)="uploadDocument()"
      >
        <mat-icon *ngIf="!isUploading">cloud_upload</mat-icon>
        <mat-spinner diameter="20" *ngIf="isUploading" style="margin-right: 8px"></mat-spinner>
        {{ isUploading ? 'Uploading...' : 'Confirm &amp; Upload' }}
      </button>
    </div>
  </div>

</div>
